import React from 'react'
import styles from './styles'
import { withStyles, Box } from '@material-ui/core'
import PricingPlanCard from './pricing-plan-card'
import PlanCard from './plan-card'
import Enterprise from '../enterprise'
import { AUDIENCES } from '../../data/pricing-json'

const PricingCard = props => {
  const { plans, handleClick, classes, loading, renderToggle, audience } = props
  const allPlansInclude = plans.find(item => item.isAllPlansInclude)
  const pricingPlans = plans.filter(item => !item.isAllPlansInclude)

  const allPlans = allPlansInclude && (
    <PricingPlanCard
      card={allPlansInclude}
      index={0}
      loading={loading}
      onClickHandler={() => {}}
    />
  )

  // Enterprise: the shared feature list on top (like Creator), then two wide
  // use-case cards and the "more learners" strip.
  if (audience === AUDIENCES.ENTERPRISE) {
    return (
      <>
        {allPlans}
        {renderToggle && renderToggle()}
        <Box className={classes.cardGrid}>
          {pricingPlans.map(card => (
            <PlanCard
              key={card.key}
              card={card}
              loading={loading}
              onClickHandler={() => handleClick(card)}
            />
          ))}
        </Box>
        <Enterprise />
      </>
    )
  }

  return (
    <>
      {allPlans}
      {renderToggle && renderToggle()}
      <Box className={classes.cardGrid}>
        {pricingPlans.map(card => (
          <PlanCard
            key={card.key}
            card={card}
            loading={loading}
            onClickHandler={() => handleClick(card)}
          />
        ))}
      </Box>
    </>
  )
}

export default withStyles(styles)(PricingCard)
